import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { BreakMode, BreakRule } from '@/lib/labor-hours';

export type AttendanceSettingsValue = {
  breakMode: BreakMode;
  breakRules: BreakRule[];
  // v0.4後半 月次実績一括入力 第2フェーズ I-4b (§6-2 項目6): 休憩の記録方式 (time_range の店舗は
  // BreaksEditor、minutes の店舗は手入力の分数)。GET /settings/attendance は元々このキーを含めて
  // 返している (resolveAttendanceSettings の値をそのまま返す) が、既存の型定義が絞っていたため追加する。
  breakRecordMode: 'minutes' | 'time_range';
};
type ResolvedAttendance = { value: AttendanceSettingsValue | null };

/** 指定ノードの休憩自動控除設定を解決する。`GET /settings/attendance` はキーを camelCase のまま
 *  返す (`AttendanceSettingsPage.tsx` の `ResolvedAttendance` と同じ形)。employment_type_id は
 *  省略しテナント/ノード共通設定にフォールバックする (勤務実績入力画面は雇用形態別の休憩ルール
 *  上書きまでは扱わない、表示専用プレビューのための簡略化)。 */
export const useAttendanceSettings = (
  nodeId: string | null | undefined, enabled = true,
): { data: AttendanceSettingsValue | undefined; isLoading: boolean } => {
  const { data, isLoading } = useQuery<ResolvedAttendance>({
    queryKey: ['attendance-settings-resolved', nodeId],
    queryFn: () => apiFetch<ResolvedAttendance>(`/settings/attendance?node_id=${encodeURIComponent(nodeId!)}`),
    enabled: enabled && !!nodeId,
  });
  return { data: data?.value ?? undefined, isLoading };
};
